import type {ClientEntitlements} from '@nursio-link/common/authorization/isEntitled';
import {isEntitled} from '@nursio-link/common/authorization/isEntitled';

import {graphqlClient} from '@/services/graphqlClient';
import {useGetEntitlementsQuery} from '@/services/graphqlHooks';

export const useEntitlements = () => {
  const getEntitlements = useGetEntitlementsQuery(graphqlClient, undefined, {
    staleTime: Infinity,
  });

  const entitlements = getEntitlements.data?.getEntitlements;

  if (!entitlements) {
    return;
  }

  return entitlements;
};

export const useEntitledForClient = (clientEntitlement: ClientEntitlements) => {
  const entitlements = useEntitlements();

  return isEntitled(entitlements || [], clientEntitlement);
};
